import { render, staticRenderFns } from "./backdrop.vue?vue&type=template&id=c50f4ac6&scoped=true&"
import script from "./backdrop.vue?vue&type=script&lang=js&"
export * from "./backdrop.vue?vue&type=script&lang=js&"
import style0 from "./backdrop.vue?vue&type=style&index=0&id=c50f4ac6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c50f4ac6",
  null
  
)

export default component.exports